import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
import { Sparkle } from '../components/Sparkle';
import { useSeo } from '../hooks/useSeo';
export const portraitSrc = 'https://cdn.magicpatterns.com/uploads/4vcUe3zvNYie49UXvfybHQ/tina-xla-sales-mentorin-podcast-studio.webp';
const portraitMobileSrc = 'https://cdn.magicpatterns.com/uploads/hrFD3p9z95MH6uvJMEHoQc/tina-xla-sales-mentorin-podcast-studio.mobile.webp';
const portraitAlt = 'Tina Xla, Sales-Mentorin und Gründerin der Hot Sales Girls Academy';
/** Transparenter Platzhalter, damit ausgeblendete Bilder nicht unnötig geladen werden. */
const blankPixel = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
export function AboutMe() {
  useSeo({
    title: 'Über Tina Xla | Hot Sales Girls Academy',
    description: 'Lerne Tina Xla kennen: 15 Jahre Erfahrung im Sales, Gründerin der Hot Sales Girls Academy und Mentorin für Frauen, die als Hot Sales Girl ortsunabhängig arbeiten wollen.',
    path: '/ueber-tina-xla',
    type: 'profile',
    image: portraitSrc
  }, {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Tina Xla',
    jobTitle: 'Gründerin der Hot Sales Girls Academy',
    image: portraitSrc,
    url: 'https://www.hotsalesgirls.com/ueber-tina-xla',
    worksFor: {
      '@type': 'Organization',
      name: 'Hot Sales Girls Academy'
    },
    sameAs: ['https://www.instagram.com/tina_xla/', 'https://www.tiktok.com/@tina_xla', 'https://www.youtube.com/@tina_xla']
  });
  return <div className="min-h-screen w-full overflow-x-hidden" data-id="element-457" data-mp="2w1howbk3s0wv">
      <div className="pink-panel relative" data-id="element-458" data-mp="2vyvhcbx7plen">
        <div className="relative z-10" data-id="element-459" data-mp="2r0k5xwr9r2ub">
          <Navbar data-id="element-460" data-mp="2r3pv1bzwe4q1" />

          <main className="relative w-full bg-cream px-4 pb-14 pt-8 sm:px-6 sm:pb-20 sm:pt-12" data-id="element-461" data-mp="2m2im39m0qzhs">
            <span aria-hidden="true" className="gold-glitter-layer-static" data-id="element-462" data-mp="2cewmkdsw42ci" />
            <span aria-hidden="true" className="gold-glitter-extra" data-id="element-463" data-mp="2cgzkdk0aazrs" />
            <div className="relative z-10 mx-auto grid max-w-[1300px] items-center gap-10 lg:grid-cols-2 lg:gap-16" data-id="element-464" data-mp="2hesqye5i1vsl">
              <div className="text-center" data-id="element-465" data-mp="23g1fkzi0uo85">
                <span className="mb-6 block text-[11px] font-semibold uppercase tracking-[0.25em] text-hot-500" data-id="element-466" data-mp="27fk2g0tel9dm">
                  Mein Warum
                </span>

                <div className="relative inline-block" data-id="element-467" data-mp="2v7h9zfptlf8x">
                  <Sparkle className="animate-sparkle -left-8 -top-2 h-8 w-8" data-id="element-468" data-mp="303fs4lkk210w" />
                  <h1 className="font-sans text-4xl font-medium text-neutral-900 sm:text-5xl" data-id="element-469" data-mp="2mdm6ec4cjwve">
                    Hi, ich bin Tina
                  </h1>
                </div>

                <picture className="contents" data-id="element-470" data-mp="3e4a3nd2wgi3s">
                  <source media="(min-width: 1024px)" srcSet={blankPixel} data-id="element-471" data-mp="3e3gte24qfagw" />
                  <source media="(max-width: 639px)" srcSet={portraitMobileSrc} data-id="element-472" data-mp="3ivib43ko5teb" />
                  <img src={portraitSrc} alt={portraitAlt} fetchPriority="high" decoding="async" className="mx-auto mt-8 w-full max-w-xl rounded-3xl border border-gold/50 object-cover shadow-2xl md:max-lg:max-w-sm lg:hidden" data-id="element-473" data-mp="17fq9o9gf1d81" />
                </picture>

                <div className="mt-6 space-y-4 text-sm leading-relaxed text-neutral-700 sm:text-base" data-id="element-474" data-mp="1c8t56n4r6wqv">
                  <p data-id="element-475" data-mp="oj8c3bevyj3v">Sales-Expertin, Unternehmerin und Visionärin.</p>
                  <p data-id="element-476" data-mp="jjcd5ql1phv6">
                    Mit 18 Jahren begann meine Reise im Door-to-Door-Vertrieb und in der Kaltakquise
                    – dort habe ich die Grundlagen des Verkaufs von Grund auf gelernt. Heute blicke
                    ich auf über 15 Jahre Erfahrung im Sales zurück, darunter High-Ticket-Sales sowie
                    der Aufbau, die Zusammenarbeit und Skalierung internationaler Sales-Teams. In
                    dieser Zeit habe ich selbst über 50 Millionen Euro eigen Umsatz im Sales generiert
                    und mit internationalen Top-Unternehmen zusammengearbeitet. Diese Erfahrung bildet
                    die Basis meiner Arbeit.
                  </p>
                  <p data-id="element-477" data-mp="ne6vlew9m331">
                    Ich weiß, welche Fähigkeiten, Strukturen und Denkweisen es braucht, um sich im
                    Sales langfristig zu etablieren und weiterzuentwickeln. Mein Ziel ist es, Frauen
                    weltweit dabei zu unterstützen, ihre Sales-Skills gezielt aufzubauen oder auf das
                    nächste Level zu heben, ihre Stärken zu erkennen und selbstbewusst ihren eigenen
                    Weg im Sales zu gehen – insbesondere in einer nach wie vor männerdominierten
                    Branche. Gemeinsam arbeiten wir an Klarheit, Kompetenz und persönlichem Wachstum
                    – Schritt für Schritt und ohne leere Versprechen.
                  </p>
                </div>

                <img src="https://cdn.magicpatterns.com/uploads/gpcTrNbCzRKwNqXuCqtteF/unterschrift-tina-xla.webp" alt="Unterschrift von Tina Xla" className="mx-auto mt-8 w-48 sm:w-56" data-id="element-478" data-mp="1l0dvibhmj792" />
              </div>

              <picture className="contents" data-id="element-479" data-mp="1l8rby6rmz3tm">
                <source media="(max-width: 1023px)" srcSet={blankPixel} data-id="element-480" data-mp="1h75t84sf7vbi" />
              <img src={portraitSrc} alt={portraitAlt} fetchPriority="high" decoding="async" className="mx-auto hidden w-full max-w-lg rounded-3xl border border-gold/50 object-cover shadow-2xl lg:mt-28 lg:block lg:self-start xl:mt-0 xl:self-center" data-id="element-481" data-mp="1h98pv7o2wmp7" />
              </picture>
            </div>
          </main>

          <Footer data-id="element-482" data-mp="203xfmn39eqjs" />
        </div>
      </div>
      <CookieBanner data-id="element-483" data-mp="2woobeox3p653" />
    </div>;
}